// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__UR0vo","expiration":"styles_expiration__KCy6r","footer":"styles_footer__rj_Gm"};